export default {
  mode: process.env.REACT_APP_ENV,
  api: {
    url: `//${process.env.REACT_APP_API_URL}`,
  },
};
